var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V16C4 16.5304 4.21071 17.0391 4.58579 17.4142C4.96086 17.7893 5.46957 18 6 18H14C14.5304 18 15.0391 17.7893 15.4142 17.4142C15.7893 17.0391 16 16.5304 16 16V7.414C15.9997 7.01631 15.8414 6.63503 15.56 6.354L11.646 2.439C11.3648 2.15798 10.9835 2.00008 10.586 2H6ZM5 4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3H10V6.5C10 6.89782 10.158 7.27936 10.4393 7.56066C10.7206 7.84196 11.1022 8 11.5 8H15V16C15 16.2652 14.8946 16.5196 14.7071 16.7071C14.5196 16.8946 14.2652 17 14 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16V4ZM14.793 7H11.5C11.3674 7 11.2402 6.94732 11.1464 6.85355C11.0527 6.75979 11 6.63261 11 6.5V3.207L14.793 7Z",
    fill: "#5E6875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.846 11.5L10.3718 9.14645C10.1665 8.95118 9.83365 8.95118 9.62837 9.14645L7.15402 11.5C6.94874 11.6953 6.94874 12.0118 7.15402 12.2071C7.35931 12.4024 7.69214 12.4024 7.89742 12.2071L9.47441 10.7071L9.47441 15.5C9.47441 15.7761 9.70975 16 10.0001 16C10.2904 16 10.5257 15.7761 10.5257 15.5L10.5257 10.7071L12.1026 12.2071C12.3079 12.4024 12.6408 12.4024 12.846 12.2071C13.0513 12.0118 13.0513 11.6953 12.846 11.5Z",
    fill: "#5E6875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFile);
export default __webpack_public_path__ + "static/media/save-file.9b3341f2c0bf999dbc77d35a91ae030f.svg";
export { ForwardRef as ReactComponent };